
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createPinia } from 'pinia'
import Rollbar from 'rollbar'
import { APP_VERSION, ROLLBAR_API_TOKEN } from './config'

require('es6-promise').polyfill();

import moment from 'moment'
import numeral from 'numeral'
import localeDE from './locales/de.js'
import localeEN from './locales/en.js'
import Logger from './services/logging.js';
import * as Sentry from "@sentry/vue";

numeral.register('locale', 'de', {
	delimiters: {
		thousands: '.',
		decimal: ','
	},
	abbreviations: {
		thousand: 'k',
		million: 'm',
		billion: 'b',
		trillion: 't'
	},
	ordinal: function (number) {
		return '.';
	},
	currency: {
		symbol: '€'
	}
});
numeral.locale('de');

let userLanguage = 'de';
if (
	window !== undefined
	&& window !== null
	&& window.localStorage !== undefined
	&& window.localStorage !== null
) {
	const settings = window.localStorage.getItem('settings');
	if (settings !== null) {
		const { locale, basket } = JSON.parse(settings)
		userLanguage = locale;
	}
}

const messages = {
	de: localeDE,
	en: localeEN
}
const i18n = createI18n({
	legacy: false,
	locale: userLanguage,
	fallbackLocale: (userLanguage == 'de') ? 'en' : 'de',
	messages
});

const pinia = createPinia()
const app = createApp({})
// import components
const files = require.context('./components/', true, /\.vue$/i)
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default))
// use libaries
// pinia
app.use(pinia)
// i18n
app.use(i18n)
// sentry
// if (process.env.MIX_APP_ENV !== 'local') {
// 	Sentry.init({
// 		dsn: "https://a39ea5b4282964128456e9fc79c9472a@sentry.lemon-blue.de:9000/4",
// 		integrations: [
// 			Sentry.browserTracingIntegration(),
// 			Sentry.replayIntegration({
// 				maskAllText: false,
// 				blockAllMedia: false,
// 			}),
// 		],
// 		// Performance Monitoring
// 		tracesSampleRate: 1.0, //  Capture 100% of the transactions
// 		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
// 		tracePropagationTargets: ["localhost", /^https:\/\/lueco-planer\.de/, /^https:\/\/5.75.177.158/],
// 		// Session Replay
// 		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
// 		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// 		environment: process.env.MIX_APP_ENV ?? 'production',
// 		release: '1.5.1'
// 	});
// }
// rollbar
const logger = new Logger()
if (process.env.MIX_APP_ENV !== 'local') {
	const rollbar = new Rollbar({
		accessToken: ROLLBAR_API_TOKEN,
		captureUncaught: true,
		captureUnhandledRejections: true,
		environment: process.env.MIX_APP_ENV ?? 'production',
		enabled: true,
		source_map_enabled: true,
		payload: {
			client: {
				javascript: {
					code_version: APP_VERSION
				}
			}
		}
	})

	app.use(rollbar)
	app.config.errorHandler = (err, vm, info) => {
		rollbar.error(err, info)
		throw err // rethrow
	}

	logger.setRollbar(rollbar)
}
app.provide('logger', logger)
// add filters
app.config.globalProperties.$filters = {
	formatDate (value) {
		if (value) {
			return moment(String(value), 'Y-MM-DD').format('DD.MM.Y')
		}
	},
	formatMoney (value) {
		return numeral(parseFloat(value)).format("0,0.00 $")
	},
	formatLength (value) {
		return numeral(parseFloat(value)).format("0,0.00")
	},
	formatPercentage (value) {
		return numeral(parseFloat(value)).format("0,0.00") + '%'
	},
	formatBoothTypeClass (type) {
		let className = "";
		switch(type) {
			case "row":
					className = "booth-row";
					break;
			case "head":
					className = "booth-head";
					break;
			case "island":
					className = "booth-island";
					break;
			case "corner_left":
					className = "booth-corner-left";
					break;
			case "corner_right":
					className = "booth-corner-right";
					break;
			default:
					break;
		}
		return className;
	},
	formatBoothTypeName (name) {
		return ("boothTypes." + value)
	},
	nl2br (value) {
		return value.replace(/(?:\r\n|\r|\n)/g, '<br />')	
	},
	replaceVatRate (text, value) {
		return text.replace('[vatRate]', value)
	}
}
// mount app
app.mount('#app')

// Vue.use(VeeValidate)

$(document).ready(function () {
	$('.nav-trigger').click(function () {
		$('side-nav').toggleClass('visible');
	});
});